import { Me } from '@models/me'
import { RouteConfig } from 'src/routes'

type Matchable = Pick<RouteConfig, 'routesForMatch' | 'matchRoutesFor'>

/**
 * Совпадает ли текущий путь с дополнительными маршрутами пункта меню.
 * matchRoutesFor сужает правило: страницы прохождения курса подсвечивают
 * "Мое обучение" только сотруднику, а куратору и админу по-прежнему
 * "Витрину курсов".
 */
const matchesExtraRoutes = (
  { routesForMatch, matchRoutesFor }: Matchable,
  pathname: string,
  me: Me
): boolean => {
  if (!routesForMatch?.length) {
    return false
  }

  if (matchRoutesFor && !matchRoutesFor(me)) {
    return false
  }

  return routesForMatch.some((route) => route.includes(pathname.slice(0, 4)))
}

export default matchesExtraRoutes
